<div class="issue-container"
     (click)="navToIssue.emit(assertionWithDetail())"
     data-testid="looks-good-item">
     <img src="assets/icons/checkmark.svg"
          alt="Looks Good" />
     <div class="info">
          <p [innerHTML]="assertionWithDetail().assertion.text"></p>
          <p class="subtext"
             [innerHTML]="assertionWithDetail().subtext"></p>
     </div>
     <i class="pi pi-chevron-right"></i>
</div>